export default __webpack_public_path__ + "static/media/shot-4.0bd071b8.png";